import {Repo} from "@services/repos/vendors/repo";
import {AxiosPromise} from "axios";

export class CurrencyRepo extends Repo{
  constructor() {
    super('currency');
  }

  getSymbols(): AxiosPromise {
    return this.http.get(this.getPath('get-symbols'));
  }

  getCurrencies(): AxiosPromise {
    return this.http.get(this.getPath("get-currencies"));
  }

  refresh(): AxiosPromise {
    return this.http.post(this.getPath('refresh'));
  }

  create(query: any = []): AxiosPromise {
    return this.http.post(this.getPath('create-currency'), query);
  }

  save(query: any = []): AxiosPromise {
    return this.http.post(this.getPath('update'), query);
  }

  updateSymbol(query: any = {}): AxiosPromise {
    return this.http.post(this.getPath('update-symbol'), query);
  }

  createSymbol(query: any = {}): AxiosPromise {
    return this.http.post(this.getPath('create-symbol'), query);
  }

  getBaseRateProviders(currencyId: string): AxiosPromise {
    return this.http.get(this.getPath('get-currency-base-rates'), { params: { currencyId } });
  }
}
